/**
 * Utility class for working with browser cookies.
 */
export default class Cookies {
	/**
	 * Gets the value of a cookie by name.
	 * @param name The name of the cookie to retrieve.
	 * @returns The cookie value if found; otherwise, an empty string.
	 */
	static get(name: string): string {
		let key = name + "=";
		let cookieList = document.cookie.split(";");
		for (let i = 0; i < cookieList.length; i++) {
			let cookie = cookieList[i].trim();
			if (cookie.indexOf(key) === 0) {
				return cookie.substring(key.length, cookie.length);
			}
		}
		return "";
	}

	/**
	 * Sets a cookie with the specified name, value, and expiration.
	 * @param name The name of the cookie.
	 * @param value The value to store in the cookie.
	 * @param expirationDays The number of days until the cookie expires, "session" for session-only cookie, or "none" for no expiration.
	 */
	static set(name: string, value: string, expirationDays: number | "session" | "none" = "session"): void {
		let cookieString = `${name}=${value};path=/`;

		if (expirationDays === "session") {
			// Session cookie - no expires attribute
			document.cookie = cookieString;
			return;
		}

		if (expirationDays === "none") {
			// No expiration - set far future date (e.g., 10 years)
			expirationDays = 10 * 365;
		}

		let d: Date = new Date();
		d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
		document.cookie = `${cookieString};expires=${d.toUTCString()}`;
	}
}
